const FAQS = [
  {
    q: "KashAssist kya hai aur yeh kirana dukaan ke liye kaise kaam karta hai?",
    a: "KashAssist ek AI munshi hai jo aapki dukaan ka billing, GST aur udhaar khata sambhalta hai. Aap WhatsApp-jaisi chat mein bolkar ya likhkar bill banate ho — jaise \"Ramesh ko 2kg atta aur 1 Maggi ka bill banao\" — aur seconds mein GST-ready bill taiyaar ho jata hai. Bill ko PDF mein download karo ya seedha customer ke WhatsApp pe forward karo. Koi accounting software seekhne ki zaroorat nahi.",
  },
  {
    q: "Kya bina GST number ke bhi bill bana sakte hain?",
    a: "Bilkul! Agar aapke paas GSTIN nahi hai to Dukaan Settings mein GST band rakho — bill pe sirf items aur total aayega, koi GST line nahi. Agar GSTIN hai to use bharte hi GST apne aap bills pe aane lagta hai, aur aap default GST % (0, 5, 12, 18 ya 28) bhi set kar sakte ho. Chat mein alag rate bologe to wahi lagega.",
  },
  {
    q: "Udhaar khata kaise track hota hai?",
    a: "Jab bhi aap bill mein \"udhaar\" bolte ho, woh customer ke khate mein judd jata hai. Khata tab mein har customer ka pending balance dikhta hai. Customer thoda-thoda karke paise de to partial payment record karo — baaki amount apne aap update ho jata hai. Roz shaam ko aapko din ka hisaab aur udhaar reminder WhatsApp pe milta hai.",
  },
  {
    q: "Kitna kharcha hai? Free trial hai kya?",
    a: "Pehle 3 bills bilkul free hain — bina signup, bina card. Uske baad KashAssist Pro sirf ₹99 per month hai jisme unlimited bills, GST invoices, udhaar khata, PDF download, WhatsApp forward aur voice input sab shamil hai. UPI (Google Pay, PhonePe, Paytm) ya card se pay kar sakte ho.",
  },
  {
    q: "Kya main Hindi ya apni bhasha mein use kar sakta hoon?",
    a: "Haan! KashAssist Hindi, English, Marathi, Gujarati, Tamil, Telugu, Kannada, Bengali, Punjabi aur Malayalam — 10 bhashaon mein kaam karta hai. Website ke upar language selector se apni bhasha chuno, AI ussi bhasha mein jawab dega. Voice note bhejke bhi bill bana sakte ho.",
  },
  {
    q: "Kya yeh WhatsApp pe bhi chalta hai?",
    a: "Haan, KashAssist WhatsApp pe bhi available hai — wahi billing, khata aur hisaab seedha aapke WhatsApp mein. Website se subscribe karne ke baad apna WhatsApp number link karo aur dukaan ka poora kaam chat se chalao. Phone mein app install karne ke liye website pe \"Install\" ka option bhi hai.",
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="max-w-4xl mx-auto px-6 py-16">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: FAQS.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
      <h2 className="font-heading font-bold text-lg md:text-xl mb-2 text-gray-900">Aksar pooche jaane waale sawaal (FAQ)</h2>
      <p className="text-sm text-gray-500 mb-8">Dukaan ke billing, GST aur udhaar khata ke baare mein sab kuch.</p>
      <div className="space-y-3">
        {FAQS.map((f, i) => (
          <details key={f.q} data-testid={`faq-item-${i}`} className="group bg-white border border-gray-200 rounded-2xl px-5 py-4 open:shadow-md transition-shadow duration-200">
            <summary className="cursor-pointer font-semibold text-[15px] text-gray-800 list-none flex justify-between items-center gap-3">
              {f.q}
              <span className="text-[#006D5B] text-xl leading-none group-open:rotate-45 transition-transform duration-200">+</span>
            </summary>
            <p className="text-sm text-gray-600 mt-3 leading-relaxed">{f.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
